import {useFormContext} from "react-hook-form";
import {SingleValue} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {ThirdPartyComponentSelect} from "@/components/thirdPartyComponentSelect/ThirdPartyComponentSelect.tsx";
import {ThirdPartyComponent, ThirdPartySubComponent} from "@/lib/queries/checks.ts";
import {ThirdPartyMonitoringType} from "@/lib/types/checks.ts";

interface ThirdPartyComponentSelectFieldProps extends SelectFieldBaseProps {
  prepend: (value: ThirdPartyComponent) => void;
  onChange?: (value: SingleValue<ThirdPartyComponent>) => void;
  groupFieldName: string;
}

export const ThirdPartyComponentSelectField = ({
  name,
  groupFieldName,
  onChange,
  prepend,
  ...rest
}: ThirdPartyComponentSelectFieldProps) => {
  const {watch} = useFormContext();
  const group = watch(groupFieldName);
  const components: ThirdPartyComponent[] = watch(name) || [];
  const addComponent = (component: SingleValue<ThirdPartyComponent>, subComponent?: ThirdPartySubComponent) => {
    if (!component || components.some(({title}) => title === component.title)) {
      return;
    }
    prepend({
      id: component.id,
      title: component.title,
      display_title: component.display_title,
      sub_title: component.sub_title,
      display_sub_title: component.display_sub_title,
      sub_title_count: component.sub_title_count,
      sub_components: subComponent ? [subComponent] : [],
      sub_component_monitoring_type:
        !subComponent && (component.sub_title_count ?? 0) < 100
          ? ThirdPartyMonitoringType.ALL
          : ThirdPartyMonitoringType.SPECIFIC,
    });
    onChange?.(component);
  };

  return (
    <SelectField
      name={name}
      {...rest}
      select={
        <ThirdPartyComponentSelect
          value={null}
          name={name}
          group={group}
          excludeTitles={components.map(({title}) => title || "")}
          onChange={(component) => addComponent(component)}
          onSubComponentSelect={addComponent}
        />
      }
    />
  );
};
